/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/4g4b5dg/screen/57537048
 */

import React, { Component } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import { isNil } from 'lodash';
import queryString from 'query-string';
import DatePicker from '@components/@core/DatePicker';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import withNavigate from '~/hocs/withNavigate';
import Employees from './Employees';
import Packets from './Packets';

const moment = extendMoment(originalMoment);

class SignatureList extends Component {
    state = {
        activeTab: queryString.parse(this.props.location?.search)?.active || 'employees',
        dateStart: moment().startOf('month').format('YYYY-MM-DD'),
        dateEnd: moment().endOf('month').format('YYYY-MM-DD'),
    };

    handleDate = (e) => {};

    handleFilter = (type, e) => {
        if (isNil(e)) return;

        if (type == 'employee' && e.length > 0) {
            if (e[0].id > 0) {
            } else {
            }
        }
    };

    handlePage = (e) => {};

    handlePer = (e) => {};

    handlePdf = (e) => {};

    handleSelectTab = (e) => {
        this.props.navigate({ search: `?active=${e}` });
        this.setState({ activeTab: e });
    };

    render() {
        const { activeTab, dateStart, dateEnd } = this.state;
        const date = moment.range(dateStart, dateEnd);

        return (
            <ErrorBoundary className="reports-signature">
                <Filter onChange={this.handleFilter} />
                <div className="card">
                    <div className="d-flex align-items-center mb-3 pt-1 pt-md-2">
                        <div className="dsl-b22 text-500 d-flex-1">Company Signature Packet Report</div>
                        <DatePicker calendar="range" append="caret" format="MMM D" align="right" as="span" value={date} onSelect={this.handleDate} />
                    </div>
                    <div className="d-flex justify-content-end cursor-pointer" onClick={this.handlePdf}>
                        <Icon name="fas fa-print" color="#343f4b" size={16} />
                    </div>
                    <Tabs id="signature-report" defaultActiveKey="employees" activeKey={activeTab} onSelect={this.handleSelectTab}>
                        <Tab key="employees" eventKey="employees" title="Employees">
                            <Employees />
                        </Tab>
                        <Tab key="packets" eventKey="packets" title="Packets">
                            <Packets />
                        </Tab>
                    </Tabs>
                    <Pagination onChange={this.handlePage} onPer={this.handlePer} />
                </div>
            </ErrorBoundary>
        );
    }
}

const SignatureListWithNavigate = withNavigate(SignatureList);
SignatureListWithNavigate.displayName = 'SignatureList';
export default SignatureListWithNavigate;
